import { Tour } from "nextstepjs";

const manageListGuide: Tour[] = [
  {
    tour: "manageList",
    steps: [
      {
        icon: "",
        title: "",
        content:
          "Create and save your shopping lists here for easy access later.",
        selector: "#add_new_list",
        side: "bottom",
        showControls: true,
        showSkip: true,
        pointerPadding: 5,
        pointerRadius: 10,
      },
    ],
  },
];

export default manageListGuide;
